import { useEffect } from 'react';

export const useClientPolling = ({
  user,
  showBooking,
  realtimeConnectedRef,
  loadClientAcceptedQuickCuts,
  loadClientHistory,
  loadClientReviews
}) => {
  useEffect(() => {
    if (!user || user.user_type !== 'client') return;
    if (showBooking) return;
    if (realtimeConnectedRef?.current) return;

    const interval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      if (showBooking || realtimeConnectedRef?.current) return;
      loadClientAcceptedQuickCuts?.();
      loadClientHistory?.();
      loadClientReviews?.();
    }, 7000);

    return () => clearInterval(interval);
  }, [
    user,
    showBooking,
    realtimeConnectedRef,
    loadClientAcceptedQuickCuts,
    loadClientHistory,
    loadClientReviews
  ]);
};
